/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from "react";
import { Fade } from "react-awesome-reveal";

const RevenueForecast = () => {
  const revenueData = [
    {
      category: "Management Fees",
      year1: "$500,000",
      year2: "$750,000",
      growth: "50%",
    },
    {
      category: "Investment Returns",
      year1: "$300,000",
      year2: "$600,000",
      growth: "100%",
    },
    {
      category: "Advisory Income",
      year1: "$200,000",
      year2: "$350,000",
      growth: "75%",
    },
    {
      category: "Total Revenue",
      year1: "$1,000,000",
      year2: "$1,700,000",
      growth: "70%",
    },
  ];

  return (
    <div className="container px-6 py-12 mx-auto ">
      <Fade bottom triggerOnce>
        {/* Introductory Text */}
        <div className="max-w-3xl mx-auto mb-12 text-center">
          <h2 className="mb-4 text-4xl font-bold text-gray-800">
            Projecting Growth Through Diversified Revenue Streams
          </h2>
          <p className="text-gray-600">
            At Katella Venture Capital LLC, our revenue model is built on a
            balanced mix of management fees, investment returns, and advisory
            income. The following sample forecast outlines expected revenue
            streams over the first two years of operations, based on
            conservative growth assumptions and anticipated deal flow.
          </p>
        </div>

        {/* Engaging Table */}
        <div className="max-w-4xl mx-auto overflow-hidden bg-white rounded-lg shadow-lg">
          <div className="overflow-x-auto">
            <table className="w-full table-auto">
              <thead>
                <tr className="text-white bg-teal-500">
                  <th className="px-6 py-4 text-sm font-semibold tracking-wider text-left uppercase">
                    Revenue Category
                  </th>
                  <th className="px-6 py-4 text-sm font-semibold tracking-wider text-center uppercase">
                    Year 1
                  </th>
                  <th className="px-6 py-4 text-sm font-semibold tracking-wider text-center uppercase">
                    Year 2
                  </th>
                  <th className="px-6 py-4 text-sm font-semibold tracking-wider text-center uppercase">
                    Growth
                  </th>
                </tr>
              </thead>
              <tbody>
                {revenueData.map((row, index) => (
                  <tr
                    key=""
                    className={`${
                      index % 2 === 0 ? "bg-gray-50" : "bg-white"
                    } hover:bg-teal-50 transition-colors duration-300 ${
                      index === revenueData.length - 1 ? "font-bold" : ""
                    }`}
                  >
                    <td className="px-6 py-4 text-left text-gray-700">
                      {row.category}
                    </td>
                    <td className="px-6 py-4 text-center text-gray-600">
                      {row.year1}
                    </td>
                    <td className="px-6 py-4 text-center text-gray-600">
                      {row.year2}
                    </td>
                    <td className="px-6 py-4 text-center text-teal-600">
                      <span className="inline-flex items-center">
                        <svg
                          className="w-4 h-4 mr-1"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M5 10l7-7m0 0l7 7m-7-7v18"
                          />
                        </svg>
                        {row.growth}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Fade>
    </div>
  );
};

export default RevenueForecast;
